import { useRef } from 'react';

const useScrollToTop = () => {
  const reference = useRef<HTMLDivElement>(null);

  const scrollToTop = (scrollOptions: ScrollToOptions = {}) => {
    if (reference.current) {
      reference.current.scrollTo({
        top: 0,
        behavior: 'smooth',
        ...scrollOptions,
      });
    }
  };

  return { reference, scrollToTop };
};

export default useScrollToTop;
